import { Divider, Typography, FormControl, Select, MenuItem, Box, Grid } from '@mui/material';
import { useEditLab } from 'context/edit-lab-context';
import React, { FC } from 'react';
import PriceListActions from './price-list-actions';
import { useTranslation } from 'react-i18next';
const PriceList: FC = () => {
    const { categories, selectedCategory, setSelectedCategory } = useEditLab();
    const { t: translate } = useTranslation(['lab-settings', 'organization']);

    const selectedCategories = categories.filter((c) => c.isSelected);
    const nonSelectedCategories = categories.filter((c) => !c.isSelected);

    return (
        <>
            <Divider sx={{ mt: 3, mb: 3 }} />
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 3 }}>
                    <Typography variant="h6">{translate('organization:PRICE_LIST')}</Typography>
                </Box>

                <Grid container>
                    <Grid item xs={12} className="categories-section edit-labs-select">
                        <Box className="category-section-block">
                            <Box className="selected-category-list" sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                {selectedCategories.map((category, index) => (
                                    <Box
                                        key={category._id}
                                        className="selected-category-item"
                                        sx={{
                                            cursor: 'pointer',
                                            p: 1,
                                            mb: 1,
                                            border: '1px solid #ddd',
                                            borderRadius: 1,
                                            backgroundColor:
                                                selectedCategory === category._id ? '#e3f2fd' : 'transparent',
                                            borderColor: selectedCategory === category._id ? '#1976d2' : '#ddd',
                                        }}
                                        onClick={() => setSelectedCategory(category._id, true)}
                                    >
                                        {index + 1}. {category.name}
                                    </Box>
                                ))}

                                {nonSelectedCategories.length > 0 && (
                                    <FormControl className="several-options">
                                        <Select
                                            value={
                                                nonSelectedCategories.some((cat) => cat._id === selectedCategory)
                                                    ? selectedCategory
                                                    : ''
                                            }
                                            onChange={(e) => setSelectedCategory(e.target.value as string, false)}
                                            displayEmpty
                                            sx={{ height: 45 }}
                                        >
                                            <MenuItem value="" disabled>
                                                + {translate('lab-settings:ADD_PRICE_LIST')}
                                            </MenuItem>
                                            {nonSelectedCategories.map((category, index) => (
                                                <MenuItem key={category._id} value={category._id}>
                                                    {index + 1}. {category.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {selectedCategory && <PriceListActions />}
        </>
    );
};

export default PriceList;
